import { useEffect } from "react";
import { useTracker } from "~/lib/fpd/tracker.client";

export default function ClickTracker() {
    const { trackClick } = useTracker();
    useEffect(() => {
        const handleClick = (event: MouseEvent) => {
            const clickedElement = event.target as HTMLElement;
            const id = clickedElement.id;
            const tag = clickedElement.tagName;
            const text = clickedElement.textContent?.trim() || "No text for target";
            trackClick(id, tag, text);
        };
        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <></>;
}
